import { I18n } from 'aws-amplify'
import { TRIAL_STATUS } from './shared/trial-status'

const Strings = () => ({
    trialNotebookTitle: I18n.get('Trial Notebook'),
    notesCount: I18n.get('notes'),
    addNoteLabel: I18n.get('Add Note'),
    addingNote: I18n.get('Adding...'),
    notePlaceholder: I18n.get('Add a new observation or note...'),
    noNotesMessage: I18n.get('No notes have been added yet. Add your first observation above.'),
    deleteNoteLabel: I18n.get('Delete note'),
    errorLoadingNotes: I18n.get('Error loading notes'),
    errorAddingNote: I18n.get('Error adding note'),
    errorDeletingNote: I18n.get('Error deleting note'),
    advanceView: I18n.get('Advanced View'),
    basicView: I18n.get('Basic View'),
    editTrialInfo: I18n.get('Edit Trial Info'),
    generatePDFReport: I18n.get('Generate PDF Report'),
    days: I18n.get('days'),
    noCropInformationFound: I18n.get('No crops data available'),
    cropDetails: I18n.get('Crop details'),
    [TRIAL_STATUS.PLANNED]: I18n.get('Planned'),
    [TRIAL_STATUS.IN_PROGRESS]: I18n.get('In Progress'),
    [TRIAL_STATUS.COMPLETED]: I18n.get('Completed'),
    [TRIAL_STATUS.CANCELLED]: I18n.get('Cancelled'),
    started: I18n.get('Started'),
    duration: I18n.get('Duration'),
    status: I18n.get('Status'),
    produce: I18n.get('Produce'),
    variety: I18n.get('Variety'),
    plantingArea: I18n.get('Planting Area'),
    hydrationMethod: I18n.get('Hydration Method'),
    seedQuantity: I18n.get('Seed Quantity'),
    estimatedSowDate: I18n.get('Estimated Sow Date'),
    sowDate: I18n.get('Sow Date'),
    estimatedTransplantDate: I18n.get('Estimated Transplant Date'),
    transplantDate: I18n.get('Transplant Date'),
    estimatedHarvestStartDate: I18n.get('Estimated Harvest Start Date'),
    harvestStartDate: I18n.get('Harvest Start Date'),
    estimatedHarvestEndDate: I18n.get('Estimated Harvest End Date'),
    harvestEndDate: I18n.get('Harvest End Date'),
    dateAndTime: I18n.get('Date & Time'),
    roofCover: I18n.get('Roof Cover'),
    secondskyVariant: I18n.get('SecondSky Variant'),
    blockingRatio: I18n.get('Blocking Ratio'),
    netType: I18n.get('Net Type'),
    secondskyInformation: I18n.get('Additional Information'),
    environmental: I18n.get('Environmental'),
    soil: I18n.get('Soil'),
    metrics: I18n.get('Metrics'),
    liveData: I18n.get('Live Data'),
    historical: I18n.get('Historical'),
    showSections: I18n.get('Show Sections'),
    showDelta: I18n.get('Show Delta'),
    sectionA: I18n.get('Section A'),
    sectionB: I18n.get('Section B'),
    delta: I18n.get('Delta'),
    clearFilter: I18n.get('Clear Filter'),
    envirosense: I18n.get('Envirosense'),
    envirosenseDevicesFilter: I18n.get('Envirosense devices filter'),
    soilsense: I18n.get('Soilsense'),
    soilsenseDevicesFilter: I18n.get('Soilsense devices filter'),
    sensorFilter: I18n.get('Sensor Filter'),
    zoneSensors: I18n.get('Sensors'),
    selectSensors: I18n.get('Select sensors...'),
    cancel: I18n.get('Cancel'),
    apply: I18n.get('Apply'),
    envirosenseDateFilterTitle: I18n.get('Envirosense Date Filter'),
    soilsenseDateFilterTitle: I18n.get('Soilsense Date Filter'),
    dateFilter: I18n.get('Date Filter'),
    dateRangeLabel: I18n.get('Date Range'),
    startDateLabel: I18n.get('Start Date'),
    endDateLabel: I18n.get('End Date'),
    graphIntervalLabel: I18n.get('Graph Interval'),
    time: I18n.get('Time'),
    customRange: I18n.get('Custom Range'),
    last24Hours: I18n.get('Last 24 Hours'),
    last7Days: I18n.get('Last 7 Days'),
    last30Days: I18n.get('Last 30 Days'),
    last90Days: I18n.get('Last 90 Days'),
    lastYear: I18n.get('Last Year'),
    '15min': I18n.get('15 Minutes'),
    '30min': I18n.get('30 Minutes'),
    '1hour': I18n.get('1 Hour'),
    '1day': I18n.get('1 Day'),
    sync: I18n.get('Sync Filters'),
    synced: I18n.get('Filters Synced'),
    syncFilters: I18n.get('Sync Filters'),
    syncedFilterInfo: I18n.get('Filters are synced with environmental metrics'),
    minValueTooltip: I18n.get('Min value (last hour)'),
    maxValueTooltip: I18n.get('Max value (last hour)'),
    businessInsights: I18n.get('Business Insights'),
    experimentalFeature: I18n.get('Experimental Feature'),
    energy: I18n.get('Energy'),
    water: I18n.get('Water'),
    yield: I18n.get('Yield'),
    fertigation: I18n.get('Fertigation'),
    bussisnessInsightInfo: I18n.get('Cumulative values since the start of the trial for the entire site '),
    totalCostSavings: I18n.get('Total Cost Savings'),
    iyris: I18n.get('Iyris'),
    control: I18n.get('Control'),
    savingsLabel: I18n.get('Savings (B-A)'),
    environmentalMetricsTitle: I18n.get('Enviromental Metrics'),
    soilMetricsTitle: I18n.get('Soil Metrics'),
    timeZoneFetchInfo: I18n.get('Calendar times are shown in your local timezone and will convert to the Trial Site timezone'),
    timeZone: I18n.get('Timezone'),
    planned: I18n.get('Planned'),
    sowed: I18n.get('Sowed'),
    transplanted: I18n.get('Transplanted'),
    harvesting: I18n.get('Harvesting'),
    harvested: I18n.get('Harvested'),
    failed: I18n.get('Failed'),
    canceled: I18n.get('Canceled'),
    trialAssistant: I18n.get('Trial Assistant'),
    executiveSummary: I18n.get('Executive Summary'),
    generateExecutiveSummary: I18n.get('Generate Executive Summary'),
    analyzingTrialData: I18n.get('Analyzing trial data and generating summary...'),
    regenerateSummary: I18n.get('Regenerate Summary'),
    audioOverview: I18n.get('Audio Overview'),
    generateAudioOverview: I18n.get('Generate Audio Overview'),
    processingVoiceSynthesis: I18n.get('Processing voice synthesis from trial data...'),
    tryAgain: I18n.get('Try Again'),
    regenerateAudio: I18n.get('Regenerate Audio'),
    askTheAssistant: I18n.get('Ask the Assistant'),
    selectQuestion: I18n.get('Select a question:'),
    analyzingTrialDataForAnswer: I18n.get('Analyzing trial data to provide accurate information...'),
    answer: I18n.get('Answer:'),
    failedToLoadAudio: I18n.get('Failed to load audio. Please try again.'),
    failedToUpdatePlayback: I18n.get('Failed to update playback position. Please try again.'),
    playbackFailed: I18n.get('Playback failed. Please try again.'),
    playbackControlFailed: I18n.get('Playback control failed. Please try again.')
})

export default Strings